module.exports = __webpack_public_path__ + "static/media/rectangle.ee415ecb.svg";